import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaStar } from 'react-icons/fa';

function Success() {
  return (
    <div className="success-container">
      <Helmet>
        <title>Order Successful - Fitness Health Blog</title>
        <meta name="description" content="Your order has been successfully placed" />
      </Helmet>

      <div className="success-content">
        <div className="success-icon">
          <FaStar color="#10ac84" />
        </div>
        
        <h1>Order Successfully Placed!</h1>
        
        <p>
          Thank you for your purchase! Your order has been successfully received and is being processed. 
          We will send you a confirmation email shortly with all the details.
        </p>
        
        <p>
          Our team is preparing your items for shipment. You can expect to receive your premium fitness 
          and health products within 3-5 business days.
        </p>

        <div style={{ marginTop: '2rem' }}>
          <Link to="/" className="btn-primary" style={{ marginRight: '1rem' }}>
            Continue Shopping
          </Link>
          <Link to="/contact" className="btn-secondary">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Success;